/**
 * Service/Usage-Based Controller
 *
 * Displays information about usage-based orders
 */

// the constructor for this object
function ServiceUsageBasedController() { }

// the object
ServiceUsageBasedController.prototype = {
    constructor: ServiceUsageBasedController,

    // the base order id
    baseOrderId: false,

    // the number of charts we'll create for use later in the controller
    maxCharts: 10,

    // initialize the controller
    init: function()
    {
        // the user must be logged in to access this page
        PortalMain.authRedirect();

        // register the route variables used by this controller
        this._registerRouteVariables();

        // set up charts
        this._registerCharts();

        PortalHelper.debugMessage('Service Usage-Based Initialized');
    },

    // run the controller
    run: function()
    {

        // get and populate generic order information
        this._getOrder();

        // get usage-based order info
        this._getUsageOrder();

        // register the events used by this controller
        this._registerEvents();

        PortalHelper.debugMessage('Service Usage-Based Controller Ran');
    },

    _registerCharts: function()
    {
        for(var i = 0; i < this.maxCharts; i++){
            var newChartObj = new PortalChart;

            var newChart = $('.boxes.clone-source').clone();

            // set up range selection dropdown to target our new chart
            $('.range-selection-dropdown', newChart).attr('data-target-chart', i);

            // set the ID of our new chart group
            $(newChart).attr('id', 'usage-' + i);

            // set the ID of our new chart
            $('.timeline-chart', newChart).attr('id', 'usage-chart-' + i);

            newChart.removeClass('clone-source');
            newChart.addClass('hidden');

            // insert our new chart into the document
            newChart.insertAfter('.boxes.clone-source');

            newChartObj.elementId = $('.timeline-chart', newChart).attr('id');

            newChartObj.type = 'area';

            this['usageChart-' + i] = newChartObj;
        }
        // removing since we're done with it
        $('.boxes.clone-source').remove();
    },

    // get the route variables and include them in the controller
    _registerRouteVariables: function()
    {
        var segments = PortalMain.getRouteSegments();

        // set the base order id
        if (segments.length == 1) {
            this.baseOrderId = segments[0];
        } else {
            // the uri is missing important pieces
            PortalHelper.sendToDashboard();
        }
    },

    // register the javascript events
    _registerEvents:  function()
    {
        // bind to any of the dropdown links
        PortalHelper.hideDropdownOnClick('.range-selection-dropdown');
        $('.range-selection-dropdown ul li a').on('click', function(){
            var selectionLink = $(this);
            PortalMain.ServiceUsageBasedController._updateChartRange(
                this.dataset.timelineRangeSeconds,
                selectionLink.parents('.range-selection-dropdown').data('component-id')
            );

            PortalMain.ServiceUsageBasedController._updateSelectedRange(this);
        });
    },

    // get the orders from the api
    _getOrder: function()
    {
        PortalMain.ServiceIndexController = new ServiceIndexController;

        PortalMain.ServiceIndexController.baseOrderId = this.baseOrderId;

        PortalMain.ServiceIndexController._getOrder();
    },

    // Gets usage-based specific information from the API
    _getUsageOrder: function()
    {

        var usageOrderRequest = new PortalRequest;
        usageOrderRequest.makeRequest(
            '/usage-based/get-usage-order',
            {
                baseOrderId: this.baseOrderId
            },
            function(data) {
                // set up usage charts based on interface type
                PortalMain.ServiceUsageBasedController._getUsageStats();
            }
        );

    },

    // retrieves historical usage information to fill our charts with
    _getUsageStats: function(startDate, endDate, componentId = '')
    {
        // defaulting to 1 month range if a start or end date not passed
        if(!(startDate instanceof Date) || !(endDate instanceof Date)) {
            var startDate = new Date();
            var endDate = new Date();

            startDate.setMonth(
                startDate.getMonth() - 3
            );
        }

        var requestOptions = {
            baseOrderId: this.baseOrderId,
            startDate: startDate.getTime() / 1000|0,
            endDate: endDate.getTime() / 1000|0,
        }

        if(componentId !== '') {
            requestOptions.customerOrderComponentId = componentId;
        }

        var usageStatsRequest = new PortalRequest;
        usageStatsRequest.makeRequest(
            '/usage-based/get-usage-stats',
            requestOptions,
            function(data) {

                if(data.length == 0) {
                    var chart = PortalMain.ServiceUsageBasedController._getChartForComponent(componentId);
                    $('#' + chart.elementId).text("No data available for this period.");
                    PortalHelper.loadingOverlay('#' + chart.elementId, false);
                }

                // the API can return any number of graphs, so we're iteraing through them here
                for(var i in data) {
                    PortalMain.ServiceUsageBasedController._populateUsageChart(data[i], startDate, endDate);
                    PortalMain.ServiceUsageBasedController._populateUsageStats(data[i]);
                }
            },
            function() {
                var chart = PortalMain.ServiceUsageBasedController._getChartForComponent(componentId);
                $('#' + chart.elementId).text("An unknown error occurred.");
                PortalHelper.loadingOverlay('#' + chart.elementId, false);
            }
        );
    },

    // takes data from the API, and uses it to populate a chart. auto-detects columns.
    _populateUsageChart: function(data, startDate, endDate)
    {

        var chart = this._getChartForComponent(data.customerOrderComponentId);

        // un-hiding the chart
        var chartElement = $('#' + chart.elementId).parents('.boxes');
        chartElement.removeClass('hidden');
        // setting the title
        $('.title', chartElement).text(data.serviceComponent);

        if(data.unitOfMeasure == 'Bytes') {
            chart.dataFormat = 'bytes';
        }

        chart.minDate = startDate;
        chart.maxDate = endDate;

        // resetting columns first
        chart.columns = [];
        for(var i in data.chartData[0]) {
            var currentField = data.chartData[0][i];
            if(currentField == 'Time') {
                chart.columns[i] = ['date', currentField];
            } else {
                chart.columns[i] = ['number', currentField];
            }
        }

        if(data.length == 1) {
            $('#' + chart.elementId).text("No data available for this period.");
        } else {
            chart.data = data.chartData;
            chart.draw();
        }

        PortalHelper.loadingOverlay('#' + chart.elementId, false);
    },

    // Fill in the usage stats from a component
    _populateUsageStats: function(data)
    {
        // get the stats css selector
        var chartGroupId = this._getChartGroupIdForComponent(data.customerOrderComponentId);
        var statsSelector = '#' + chartGroupId + ' .stats';

        // hide if there are no recent charges
        if (data.recentCharge == null) {
            $(statsSelector).addClass('hidden');
            return;
        }

        var unitOfMeasure = data.recentCharge.unitOfMeasure;

        // set the usage
        if (unitOfMeasure == 'GB') {
            var quantity = PortalHelper.formatBytes(data.recentCharge.valueAmount, 'GB', 'GB')[0];
        } else {
            var quantity = parseInt(data.recentCharge.valueAmount);
        }

        var quantityFormatted = quantity.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");

        $('.usage span:nth-child(1)', statsSelector).html(quantityFormatted);
        $('.usage span:nth-child(2)', statsSelector).html(unitOfMeasure);

        // set the rate
        var rate = data.recentCharge.dollarAmount / quantity;
        rate = isNaN(rate) ? 0 : parseFloat(rate).toFixed(2);
        rate = PortalHelper.numberToDollars(rate, 2, true);
        $('.rate span:nth-child(1)', statsSelector).html(rate);
        $('.rate span:nth-child(2)', statsSelector).html('/' + unitOfMeasure);

        // set the amount
        var amount = PortalHelper.numberToDollars(data.recentCharge.dollarAmount);
        $('.amount span', statsSelector).html(amount);

        // set the date
        var date = PortalHelper.formatDate(data.recentCharge.date);
        $('.date', statsSelector).html(date);

        PortalHelper.loadingOverlay(statsSelector, false);
    },

    // changes what date range is displayed
    _updateChartRange: function(dateRangeSeconds, componentId)
    {
        var chart = this._getChartForComponent(componentId);

        PortalHelper.loadingOverlay('#' + chart.elementId, true);

        var endDate = new Date();
        var startDate = new Date(
            endDate.getTime()
            - (dateRangeSeconds * 1000)
        );

        this._getUsageStats(startDate, endDate, componentId);

    },

    // adds interactivity to the dropdown range selection
    _updateSelectedRange: function(element)
    {
        var selectedElementText = $(element).text();
        var selectedElementParent = $(element).parents('.selection-popup')
        $('.selection-text', selectedElementParent).text(selectedElementText);
    },

    // returns a chart object that is associated with the component ID provided.
    _getChartForComponent: function(componentId)
    {
        var currentChart = false;
        // finding chart based on component ID
        $('.range-selection-dropdown').each(function(){
            if(this.dataset.componentId == componentId) {
                currentChart = this.dataset.targetChart;
            }
        });

        // if no chart exists with the component id, find the first one without a component
        if(currentChart == false) {
            $('.range-selection-dropdown').each(function(){
                if(this.dataset.componentId == undefined){
                    this.dataset.componentId = componentId;
                    currentChart = this.dataset.targetChart;
                    return false;
                }
            })
        }

        return this['usageChart-' + currentChart];
    },

    // returns the chart group id from a given component
    _getChartGroupIdForComponent: function(componentId)
    {
        var chartGroupId = false;

        // finding chart group based on component ID
        $('.range-selection-dropdown').each(function(){
            if(this.dataset.componentId == componentId) {
                chartGroupId = $(this).closest('.boxes').attr('id');
            }
        });

        return chartGroupId;
    },

}